import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WaterSupplier } from '@ui/water/interfaces/water-supplier';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WaterService {
    public static readonly baseUri: string = `${environment.apiUri}/water`;

    constructor(private readonly httpClient: HttpClient) {}

    public getWaterSuppliers(): Observable<WaterSupplier[]> {
        return this.httpClient.get<WaterSupplier[]>(`${WaterService.baseUri}/water-suppliers`);
    }
}
